import { render, staticRenderFns } from "./SyllabusListRemoveSyllabuses.vue?vue&type=template&id=5326edc4&scoped=true&"
import script from "./SyllabusListRemoveSyllabuses.vue?vue&type=script&lang=js&"
export * from "./SyllabusListRemoveSyllabuses.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusListRemoveSyllabuses.vue?vue&type=style&index=0&id=5326edc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326edc4",
  null
  
)

export default component.exports